/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ref_TitleInputs */

const en_viewer_ref_title = /** @type {(inputs: Viewer_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Node types and path notation`)
};

const ko_viewer_ref_title = /** @type {(inputs: Viewer_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`노드 타입과 경로 표기`)
};

const ja_viewer_ref_title = /** @type {(inputs: Viewer_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ノードの型とパス表記`)
};

/**
* | output |
* | --- |
* | "Node types and path notation" |
*
* @param {Viewer_Ref_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ref_title = /** @type {((inputs?: Viewer_Ref_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ref_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ref_title(inputs)
	if (locale === "ko") return ko_viewer_ref_title(inputs)
	return ja_viewer_ref_title(inputs)
});